// Settings: one tab per area; which tabs exist depends on the role, and a step
// whose tab is not there is skipped automatically.
const settings = {
  title: 'Settings',
  steps: ({ access, isPlatform, companyName }) => [
    {
      target: 'settings-tabs',
      title: 'Settings is a row of tabs',
      body: access.isOrg2
        ? 'Each tab is one part of your company: your rates, your sites, your fleet and the people who work for you. Tabs you cannot change are shown read-only.'
        : 'Each tab is one part of the operation. You only see the tabs your role can use.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-rates',
      title: 'Rate Management',
      body: access.isOrg2
        ? 'The rates you agreed to, by service and vehicle class, exactly as on your signed rate agreement.'
        : 'What providers are paid per service and vehicle class, by region. These are the numbers that go on every provider rate agreement, so change them with care.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-dashboard',
      title: 'Try it: open Dashboard settings',
      body: 'Click the Dashboard tab.',
      action: 'click'
    },
    {
      target: 'settings-panel',
      title: 'How dispatch behaves',
      body: access.dispatchSettings
        ? 'The dispatch radius (how far from the customer to look for drivers), how long a driver has to answer an offer, ETA limits, and the alert sound this browser plays when a job needs attention.'
        : 'The alert sound this browser plays when a job needs attention, and how the dashboard looks for you.',
      placement: 'top'
    },
    {
      target: 'settings-tab-users',
      title: 'Users',
      body: access.isOrg2
        ? 'Everyone who signs in for your company: dispatchers, admins, answering service, drivers. Each user has a primary role and secondary roles that decide what they can see and do.'
        : `Everyone who signs in: ${companyName}'s own staff (Org ${isPlatform ? '1' : '3'}) and each provider's people (Org ${isPlatform ? '2' : '4'}). Roles and regions decide what each person sees.`,
      placement: 'bottom'
    },
    {
      target: 'settings-tab-drivers',
      title: 'Drivers',
      body: 'Drivers are users with the driver role plus a truck and a licence on file. A driver only receives offers while on duty in the driver app and inside the dispatch radius.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-fleet',
      title: 'Fleet',
      body: 'Trucks and their capabilities (flatbed, wheel-lift, heavy). A job for a vehicle class only goes to drivers whose truck can take it.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-sites',
      title: 'Sites',
      body: access.isOrg2
        ? 'Your yards and offices, with their hours and contact numbers. Dispatch measures distance from the site that is on duty.'
        : 'Every provider facility with its region, hours and contacts. A facility that is off duty is never offered a job.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-backgroundChecks',
      title: 'Background checks',
      body: 'Who has a current background check on file and who is due. Drivers without one are flagged.',
      placement: 'bottom',
      when: (c) => !c.access.isOrg2
    },
    {
      target: 'settings-tab-insurance',
      title: 'Insurance',
      body: 'Each provider\'s certificates of insurance with their expiry dates. A lapsed policy pauses that provider\'s offers until a new certificate is uploaded.',
      placement: 'bottom',
      when: (c) => !c.access.isOrg2
    },
    {
      target: 'settings-tab-terms',
      title: 'Terms & Signatures',
      body: 'The terms a customer signs on their phone before work starts (tow authorisation, damage waiver) and every signature collected, by job.',
      placement: 'bottom'
    },
    {
      target: 'settings-tab-incentives',
      title: 'Incentives',
      body: 'The on-time arrival bonus: switch it on, set the targets and the amounts; payouts add it automatically.',
      placement: 'bottom',
      when: (c) => c.access.ownerConsole
    },
    {
      target: 'settings-tab-hiringMarketing',
      title: 'Hiring & Marketing',
      body: 'A pointer to the Owner Console, where the website, memberships, hiring and notifications are managed. That page has its own tour.',
      placement: 'bottom',
      when: (c) => c.access.ownerConsole
    },
    {
      target: null,
      title: 'That is Settings',
      body: 'Replay this at any time from the ? button. The written help (? → Help & tutorials) explains each tab in more detail.'
    }
  ]
};

export default settings;
